import React from "react";
import { Card as NextCard } from "@nextui-org/react";

const TokenSelectButton = React.memo(({ onClick, token, getTokenLogoUrl }) => (
    <NextCard
        isPressable
        isHoverable
        variant="bordered"
        css={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: 'black',
            color: 'white',
            borderRadius: '25px',
            padding: '0px',
            marginBottom: '0px',
            //maxWidth: '50%',
            //minWidth: '60%',
            width: '100%',
            minHeight: '45px',
            cursor: 'pointer',
            overflow: 'hidden',
            marginBottom: '-10px',
        }}
        onClick={onClick}
    >
        <NextCard.Body style={{
            padding: '3px',
            overflow: 'hidden',
        }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '5px', fontWeight: 'bold', fontSize: '18px' }}>
                {token && (
                    <img src={getTokenLogoUrl(token)} alt={token.label} style={{ width: '25px' }} />
                )}
                <span>{token ? token.label : 'Select Token'}</span>
                {/* <Text size={18} css={{ color: 'white', fontWeight: 'bold',}}>{token ? token.label : 'Select Token'}</Text> */}
                <i className="pi pi-chevron-down" style={{ fontSize: '0.5em', marginTop: '3px', marginLeft: '3px' }}></i>
            </div>
        </NextCard.Body>
    </NextCard>
));

export default TokenSelectButton;